import React from "react";
import { Form, Modal } from "react-bootstrap";
import { ReactComponent as Whiteclose } from "../../assets/images/white-close.svg";
import { Backdrop, CircularProgress, Drawer } from "@mui/material";
import { NotificationManager } from "react-notifications";
import validator from "validator";
import { connect } from "react-redux";
import { selectLoginStatus } from "../../store/signIn/signIn.selectors";
import { selectemployeeData } from "../../store/home/home.selectors";
import { bindActionCreators } from "redux";
import AppConfig from "../../config/app.config";
import UserService from "../../services/user/user.service";

const removeExtraSpace = (s) => s.trim().replace(/\s/g, "");

const mapStateToProps = (state) => {
  return {
    selectLoginStatus: selectLoginStatus(state),
    employeeData: selectemployeeData(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators({}, dispatch),
});

class ForgotPasswordOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: 0,
      email: "",
    };
  }

  componentDidMount() {
    if (this.props.employeeData?.employeeId != null) {
      this.setState({ email: "" });
      this.props.close();
    }
  }

  handleEmailChange = (event) => {
    this.setState({ email: removeExtraSpace(event.target.value) });
  };

  sendResetLink = async () => {
    if (this.state.email.trim() === "") {
      NotificationManager.warning("Please Enter Email.", "", 2000);
    } else if (!validator.isEmail(this.state.email)) {
      NotificationManager.warning("Please Enter Valid Email.", "", 2000);
    } else {
      this.setState({ isLoading: 1 });
      try {
        const payload = {
          emailAddress: this.state.email,
          subscriptionId: AppConfig.API.SUBSCRIPTION_ID,
          verticalId: AppConfig.API.VERTICAL_ID,
          appId: AppConfig.API.APP_ID,
        };
        const res = await UserService.sendResetPasswordLink(payload);
        if (res.error != null) {
          if (res.error?.response?.data?.message != null) {
            NotificationManager.error(
              "",
              res.error.response.data.message,
              3000
            );
          } else {
            NotificationManager.error(
              "",
              "Could not Send reset password link.",
              3000
            );
          }
          this.setState({ isLoading: 0 });
        } else {
          if (res["status"]) {
            NotificationManager.success(
              "",
              "Reset Password Link is sent to your email.",
              3000
            );
            this.setState({ isLoading: 0, email: "" });
            this.setState({ email: "" });
            this.props.close();
            this.props.showSigninOverlay();
          } else {
            NotificationManager.error(
              "",
              "Could not Send reset password link.",
              3000
            );
            this.setState({ isLoading: 0 });
          }
        }
      } catch (err) {
        this.setState({ isLoading: 0 });
      }
    }
  };

  render() {
    return (
      <>
        <Modal
          enforceFocus={false}
          show={this.props.visible}
          onHide={() => {
            this.setState({ email: "" });
            this.props.close();
          }}
          backdrop="static"
          keyboard={false}
          centered
          id="signin-modal"
        >
          {this.state.isLoading === 1 && (
            <Backdrop style={{ zIndex: 9999999, color: "#fa96c8" }} open>
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
          <div className="mobile-registration">
            <div className="mobile-register">
              <p>Forgot Password</p>
              <Whiteclose
                className="closeicon"
                onClick={() => {
                  this.setState({ email: "" });
                  this.props.close();
                }}
              />
            </div>
            <div className="mobile-registration">
              <div className="mobile-register-details">
                <img
                  src={require("../../assets/images/electrified-black.png")}
                  alt="logo"
                  className="black-logo"
                ></img>
                <Form.Group>
                  <label className="label">Email</label>
                  <Form.Control
                    type="text"
                    className="register-email"
                    placeholder="email"
                    value={this.state.email}
                    onChange={this.handleEmailChange}
                    onKeyDown={(e) => {
                      if (e.key === " ") {
                        e.preventDefault();
                      }
                    }}
                    autoComplete="off"
                    required
                  />
                </Form.Group>
                <button
                  onClick={this.sendResetLink}
                  type="button"
                  className="header-mob-btn"
                  id="Send-ResetLink"
                >
                  Send Reset Link
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <Drawer
          anchor="right"
          open={this.props.visible}
          onClose={() => {
            this.setState({ email: "" });
            this.props.close();
          }}
          id="set-mob-drawer"
        >
          {this.state.isLoading === 1 && (
            <Backdrop style={{ zIndex: 9999999, color: "#fa96c8" }} open>
              <CircularProgress color="inherit" />
            </Backdrop>
          )}

          <div id="togglemenu-mobile">
            <div className="close-icon">
              <Whiteclose
                className="drawerclose-icon"
                onClick={() => {
                  this.setState({ email: "" });
                  this.props.close();
                }}
              />
            </div>
            <div className="mobile-registration">
              <div className="mobile-register">
                <p>Forgot Password</p>
              </div>
              <div className="mobile-registration" id="mobile-signin">
                <div className="mobile-register-details">
                  <img
                    src={require("../../assets/images/electrified-black.png")}
                    alt="logo"
                    className="black-logo"
                  />
                  <Form.Group>
                    <label className="label">Email</label>
                    <Form.Control
                      type="text"
                      className="register-email"
                      placeholder="email"
                      value={this.state.email}
                      onChange={this.handleEmailChange}
                      onKeyDown={(e) => {
                        if (e.key === " ") {
                          e.preventDefault();
                        }
                      }}
                      autoComplete="off"
                      required
                    />
                  </Form.Group>
                  <button
                    onClick={this.sendResetLink}
                    type="button"
                    className="header-mob-btn"
                  >
                    Send Reset Link
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Drawer>
      </>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPasswordOverlay);
